import React, { Component } from 'react'
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts'

class DashboardPieChart extends Component {
  render () {
    return (
      <div>

        <h3 style={{ textAlign: 'center' }}>Efficiency</h3>

        <div style={{ height: 200 }}>
          <ResponsiveContainer>
            <PieChart>

              <Pie data={this.props.data} innerRadius={30} outerRadius={60} fill='#82ca9d'>
                {this.props.data.map(entry => <Cell fill={entry.color} />)}
              </Pie>

              <Tooltip />
              <Legend layout='vertical' iconType='circle' />

            </PieChart>
          </ResponsiveContainer>
        </div>

      </div>
    )
  }
}

export default DashboardPieChart



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardPieChart.js